import React, { ReactNode } from "react";
import { StaticImage } from "gatsby-plugin-image";
import ParallaxBanner from "~/components/ParallaxBanner";
import FunExperience from "~/components/FunExperience";
import gatekeeperScreenshotImage from "~/images/Gatekeeper_cropped.jpg";
import WhatStudentsNeed from "~/components/WhatStudentsNeed";
import SimpleVerticalTextAndButtons, {
  SimpleVerticalTextAndButtonsProps,
} from "~/components/SimpleVerticalTextAndButtons";
import StandardTestimonials from "~/components/StandardTestimonials";
import CostBenefits from "~/features/marketing/CostBenefits";
import LegUpSection from "~/components/LegUpSection";
import video720 from "~/images/demo-video-720.mp4";
import "~/features/marketing/learn-more.css";

type GetStartedLandingPageProps = {
  readonly topText?: ReactNode;
  readonly topButtons?: SimpleVerticalTextAndButtonsProps["buttons"];
};

function GetStartedLandingPage({
  topText,
  topButtons,
}: GetStartedLandingPageProps) {
  return (
    <div
      className="Site-inner Site-inner--index"
      id="yui_3_17_2_1_1651536660296_82"
    >
      <header className="Header Header--bottom">
        <div
          className="Header-inner Header-inner--bottom"
          data-nc-group="bottom"
        >
          <div data-nc-container="bottom-left" />
          <div data-nc-container="bottom-center" />
          <div data-nc-container="bottom-right" />
        </div>
      </header>
      <div className="Content-outer" id="yui_3_17_2_1_1651536660296_81">
        <main
          className="Index"
          data-collection-id="5efe203b529d2c2a9d9f7d90"
          data-controller="IndexFirstSectionHeight, IndexNavigation"
          id="yui_3_17_2_1_1651536660296_80"
          data-controllers-bound="IndexFirstSectionHeight, IndexNavigation"
        >
          <SimpleVerticalTextAndButtons
            title={
              <>
                Don&apos;t let Algebra, aka the <em>gatekeeper</em>, keep your
                students from their goals!
                <br />
                <span style={{ fontSize: "1.5rem" }}>
                  Unlock your child&apos;s confidence in algebra with{" "}
                  <b>our award‑winning 3D adventure game!</b>
                </span>
              </>
            }
            text={topText}
            buttons={topButtons}
          />
          <ParallaxBanner
            id="bannerwithvideo"
            image={gatekeeperScreenshotImage}
            title="ProblemScape for Introductory Algebra"
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 16,
              }}
            >
              <StaticImage
                src="../../images/ps-logo-subtitle.png"
                alt="ProblemScape Logo"
                width={200}
                placeholder="none"
              />
              <p style={{ whiteSpace: "pre-wrap" }}>
                ProblemScape is a problem-based learning course for introductory
                algebra. The adventure game aligns with Common Core as well as
                most other state standards.
              </p>
            </div>
            <div style={{ width: "100%" }}>
              <div
                className="intrinsic"
                style={{ maxWidth: "100%", position: "relative" }}
              >
                <video loop autoPlay controls muted>
                  <source src={video720} type="video/mp4" />
                </video>
                {/*<div
                  className="embed-block-wrapper "
                  style={{ paddingBottom: "56.20609%", position: "relative" }}
                >
                  <iframe
                    width="1280"
                    height="720"
                    src="https://www.youtube.com/embed/9upkfd1y-2A"
                    title="ProblemScape Trailer"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      height: "100%",
                      left: 0,
                      position: "absolute",
                      top: 0,
                      width: "100%",
                    }}
                  />
                </div>*/}
              </div>
            </div>
          </ParallaxBanner>

          <CostBenefits />
          <FunExperience />
          <WhatStudentsNeed />
          <StandardTestimonials imageBackground />
          <LegUpSection />

          <nav className="Index-nav">
            <div className="Index-nav-inner">
              <a href="#introduction-2" className="Index-nav-item active">
                <div className="Index-nav-indicator" />
                <div className="Index-nav-text">
                  <span>Introduction (Copy)</span>
                </div>
              </a>
              <a href="#bannerwithvideo" className="Index-nav-item">
                <div className="Index-nav-indicator" />
                <div className="Index-nav-text">
                  <span>Banner (Copy)</span>
                </div>
              </a>
              <a href="#download-links" className="Index-nav-item">
                <div className="Index-nav-indicator" />
                <div className="Index-nav-text">
                  <span>App downloads</span>
                </div>
              </a>
              <a href="#pshelps" className="Index-nav-item">
                <div className="Index-nav-indicator" />
                <div className="Index-nav-text">
                  <span>ProblemScape Helps</span>
                </div>
              </a>
              <a href="#new-page-1" className="Index-nav-item">
                <div className="Index-nav-indicator" />
                <div className="Index-nav-text">
                  <span>New Page</span>
                </div>
              </a>
            </div>
          </nav>
        </main>
      </div>
    </div>
  );
}

export default GetStartedLandingPage;
